var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatbord01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 342.67 159.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-2{clip-path:url(#clip-path);}.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "-69.61 159.83 366.52 159.83 366.52 -31.03 -69.61 -31.03 -69.61 159.83"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "284.2 18.98 265.19 16.1 77.75 16.1 64.94 17.42 47.35 23.66 33.2 34.67 22.09 48.71 15.64 66.53 14.6 86.03 19.3 104.33 28.79 120.02 42.31 132.29 58.99 140.27 77.72 143.06 268.55 143.06 295.73 135.38 310 124.55 321.13 109.61 327.52 92.6 328.43 73.07 323.75 54.62 314.08 39.02 300.76 26.9 284.2 18.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "279.46 21.2 261.17 18.41 80.59 18.41 68.27 19.7 51.31 25.73 37.66 36.32 26.98 49.82 20.77 67.01 19.75 85.79 24.29 103.43 33.41 118.52 46.45 130.37 62.53 138.02 80.56 140.72 264.4 140.72 290.6 133.34 304.33 122.9 315.07 108.53 321.19 92.12 322.1 73.31 317.56 55.52 308.3 40.49 295.45 28.82 279.46 21.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatbord01);
export default __webpack_public_path__ + "static/media/matbord-01.03ce62fa9f023e35077031a3072c076c.svg";
export { ForwardRef as ReactComponent };